import type { ModelSchema } from '@ember-data/store/types';

import type { RecordData } from 'webapp-types';

import BlockSerializer from 'webapp/serializers/block';

export default class BlockPreviewSerializer extends BlockSerializer {
	override normalize(
		typeClass: ModelSchema,
		json: RecordData.BlockPreview.Raw | RecordData.BlockPreview.Serialized,
		prop: string | undefined,
	) {
		const data = { ...json };

		// overwrite "settings" with the ones in "changes"
		if (data.changes?.settings) {
			data.settings = { ...data.settings, ...data.changes.settings };
		}

		// sometimes when FE sends {}, BE returns [], and then we can run into object assignment issues
		if (data.changes && !Object.keys(data.changes).length) {
			data.changes = {};
		}

		return super.normalize(typeClass, data, prop);
	}
}
